import { ErrorTypes } from './generated/api.enum';
import type { Components } from './generated/api';

/**
 * Default error when backend claims an error
 */
export class ApiError extends Error {
  requestInfo: unknown;
  responseInfo: unknown;
  errorType: Components.Schemas.ErrorTypes;

  constructor(apiResponse?: any, requestInfo: unknown = {}, responseInfo: unknown = {}) {
    const errorType = apiResponse ? (apiResponse.error as Components.Schemas.ErrorTypes) : ErrorTypes.UNKNOWN;

    super(errorType);
    Object.setPrototypeOf(this, ApiError.prototype);

    this.requestInfo = requestInfo;
    this.responseInfo = responseInfo;
    this.errorType = errorType;
  }

  public getErrorType(): Components.Schemas.ErrorTypes {
    return this.errorType;
  }
}
